<template>
  <div class="pay-method-root">
    <div v-if="showDepositSection" class="pay-method deposit-pay">
      <h1>{{ $t('message.home.useDepositBalance') }}</h1>
      <ul class="pay-method-content">
        <li class="pay-method-item flex-between">
          <div class="pay-method-item-left flex-start">
            <p class="name">
              <span>{{ $t('message.home.availableBalance') }}</span>
              <span class="amount">{{ priceFmt(availableBalance) }}</span>
            </p>
          </div>
          <el-switch :value="useDepositBalance" @change="onDepositToggle"></el-switch>
        </li>
        <li v-if="useDepositBalance" class="pay-method-item flex-between deposit-input-row">
          <div class="pay-method-item-left flex-start">
            <span class="deposit-label">{{ $t('message.home.depositDeduct') }}</span>
            <el-input-number
              :value="balanceInput"
              :min="0"
              :max="maxDepositAmount"
              :precision="2"
              :step="0.01"
              size="small"
              @change="onBalanceChange"
            ></el-input-number>
            <el-button type="text" class="deposit-max-btn" @click="applyMaxDeposit">
              {{ $t('message.home.useMaxDeposit') }}
            </el-button>
          </div>
        </li>
      </ul>
    </div>

    <div class="pay-method">
      <h1 v-if="showTitle">{{ $t('message.home.paymentMethod') }}</h1>
      <ul class="pay-method-content">
        <li
          v-for="item in paymentOptions"
          :key="item.value"
          class="pay-method-item flex-between"
        >
          <div class="pay-method-item-left flex-start">
            <img :src="item.icon" alt="" :style="item.iconStyle" />
            <p class="name">
              <span>{{ item.label }}</span>
            </p>
          </div>
          <el-radio v-model="selectedMethod" :label="item.value"></el-radio>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '@/util'

export default {
  name: 'EsPayMethod',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: 'bizSystem',
    },
    availableBalance: {
      type: [Number, String],
      default: 0,
    },
    amountPayable: {
      type: [Number, String],
      default: 0,
    },
    useDepositBalance: {
      type: Boolean,
      default: false,
    },
    balanceInput: {
      type: Number,
      default: 0,
    },
    showDeposit: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectedMethod: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      },
    },
    showDepositSection() {
      return this.showDeposit && this.parseAmount(this.availableBalance) > 0 && this.parseAmount(this.amountPayable) > 0
    },
    maxDepositAmount() {
      return Math.min(this.parseAmount(this.availableBalance), this.parseAmount(this.amountPayable))
    },
    paymentOptions() {
      return [
        {
          value: 'bizSystem',
          label: 'Biz System',
          icon: require('@/assets/image/Union.png'),
        },
        {
          value: 'paypalPayment',
          label: this.$t('message.home.payPal'),
          icon: require('@/assets/image/pay.png'),
          iconStyle: { height: '28px' },
        },
        {
          value: 'stripePayment',
          label: 'Stripe',
          icon: require('@/assets/image/stripe.svg'),
          iconStyle: { height: '28px' },
        },
      ]
    },
  },
  methods: {
    parseAmount(val) {
      const n = Number(val)
      return Number.isFinite(n) ? n : 0
    },
    priceFmt(num) {
      return formatCurrency(num, { estimate: true })
    },
    onDepositToggle(enabled) {
      this.$emit('update:useDepositBalance', enabled)
      if (enabled) {
        this.applyMaxDeposit()
      } else {
        this.$emit('update:balanceInput', 0)
        this.$emit('deposit-change', 0)
      }
    },
    applyMaxDeposit() {
      const max = this.maxDepositAmount
      this.$emit('update:useDepositBalance', max > 0)
      this.$emit('update:balanceInput', max)
      this.$emit('deposit-change', max)
    },
    onBalanceChange(val) {
      let b = this.parseAmount(val)
      const max = this.maxDepositAmount
      if (b > max) b = max
      if (b < 0) b = 0
      this.$emit('update:balanceInput', b)
      this.$emit('update:useDepositBalance', b > 0)
      this.$emit('deposit-change', b)
    },
  },
}
</script>

<style lang="scss">
html[dir="rtl"] {
  .pay-method-item-left .name {
    margin-right: 5px;
  }
}
.pay-method-root {
  .deposit-label {
    margin-right: 8px;
    white-space: nowrap;
  }
  .deposit-max-btn {
    margin-left: 8px;
  }
}
.pay-method {
  h1 {
    font-weight: 600;
    font-size: 24px;
    color: var(--color-title);
    margin: 18px 0;
  }

  &-content {
    background: linear-gradient(0deg, #fff7ec, #fff7ec), #eeeeee;
    border-radius: 4px;
    padding: 0 28px;
  }

  &-item {
    padding: 15px 0;
    &-left {
      img {
        width: 20px;
      }
      .name {
        min-width: 200px;
        margin-left: 5px;
        span:first-child {
          font-weight: 600;
          font-size: 14px;
          color: var(--color-black);
        }
      }
      .amount {
        color: var(--color-price);
        font-weight: 600;
        margin-left: 8px;
      }
    }
    .el-radio__label {
      display: none;
    }
    .el-radio__inner {
      background-color: #d9d9d9;
    }
  }
}
</style>
